import React, {useEffect, useState} from "react";
import './subjects.scss';
import CourseHeader from "../../../shared/components/AppHeader";
import SubjectCards from "../../../shared/components/CourseComponents/SubjectCards";
import SubjectForm from "../../../shared/components/CourseComponents/SubjectForm";
import SubjectService from "../../../services/CourseServices/SubjectService/subject.service";
import {withRouter} from "react-router-dom";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import EmptyState from "../../../shared/components/EmptyState";

const Subjects = (props: any) => {

    const classroomId = props.match?.params?.classId;

    useEffect(()=>{
        fetchSubjects(1)
    },[props])

    const [subjects,setSubjects] = useState<any>([]);
    const [formVisible,setFormVisible] = useState<boolean>(false)
    const [paginationMeta,setPaginationMeta] = useState<any>();
    const [currentPageNumber,setCurrentPageNumber] = useState<number>(1);

    const fetchSubjects = (pageNumber: number, searchString?:string) => {

        let queryParams = `?page=${pageNumber}&class_room_id=${classroomId}&search=${searchString || ''}`

        SubjectService.getClassroomSubjectsList(queryParams,
            (subjects:any,pageMeta:any)=>{
                setSubjects([...subjects])
                setPaginationMeta(pageMeta)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const handleSearch = (value:string) => {
        fetchSubjects(currentPageNumber,value)
    }

    const handlePageChange = (page:number) => {
        fetchSubjects(page);
        setCurrentPageNumber(page);
    }

    return (
        <div className='page-view'>
            <SubjectForm title="New Subject"
                         visible={formVisible}
                         setVisible={setFormVisible}
                         refreshList={fetchSubjects}
                         currentPageNumber={currentPageNumber}
                         classroomId={classroomId}
            />
            <CourseHeader headerText='Subjects'
                          handleSearch={handleSearch}
                          handleHeaderAction={()=>setFormVisible(true)}
                          buttonText='Subject'
                          showBreadCrumb={true}
            />
            {subjects.length !== 0 ?
                <>
                    <SubjectCards courses={subjects}
                                  refreshList={fetchSubjects}
                                  currentPageNumber={currentPageNumber}
                                  classroomId={classroomId}
                    />
                    <PaginationComponent handlePageChange={handlePageChange}
                                         paginationMeta={paginationMeta}
                    />
                </>
                :
                <EmptyState text={'No subjects found.'}/>
            }
        </div>
    )
}

export default withRouter(Subjects);
